import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './ErrorBoundary'
import { getCesiumBaseUrl, getCurrentAppPathname, navigateToAppPath } from './runtime'
import './styles.css'

// Must be set before Cesium is imported anywhere (lazy chunks included)
// This tells Cesium where to find its Workers, Assets, etc. at runtime.
// The files are served from public/cesium/ via Vite's static asset handling.
;(window as unknown as Record<string, unknown>).CESIUM_BASE_URL = getCesiumBaseUrl()

function getStoredToken(): string | null {
  return localStorage.getItem('godseye_token') || sessionStorage.getItem('godseye_token')
}

function getRoute() {
  const path = getCurrentAppPathname().replace(/\/+$/, '') || '/'
  if (path === '/login') return 'login'
  if (path === '/' || path === '/landing' || path === '/home') return 'landing'
  // Guard /app — redirect to login if no token present
  if (path === '/app' || path.startsWith('/app/')) {
    if (!getStoredToken()) {
      navigateToAppPath('/login', true)
      return 'login'
    }
    return 'app'
  }
  return 'app'
}

const route = getRoute()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      {route === 'app' ? <App /> : <App marketingRoute={route} />}
    </ErrorBoundary>
  </React.StrictMode>,
)
